import React from "react";
import { css, frames, glyphs, mediaQueriesNumbers, useMediaQuery } from "../../Styles";
import { AicoConnection, PageHeader, TableLayout, ReactiveTable, NewButton, LoadingSpinner } from "../../Components";
import { ButtonTypes, TableStyles_Types } from "../../Definitions";
import { getCoreRowModel, getFilteredRowModel, getSortedRowModel, useReactTable } from "@tanstack/react-table";
import { GenericRow, useColumnConstructor } from "../Tables/_Tables/useColumnConstructor";
import { useTranslation } from "react-i18next";
interface GenericDeviceTableProps<T extends GenericRow> {
	title: string;
	subTitle?: string;
	columnsData: any[];
	data?: T[];
	loading: boolean;
	error?: any;
	onFetch: () => void;
	tabButtons?: JSX.Element[]
}

export function GenericDeviceTable<T extends GenericRow>({
	title,
	subTitle,
	columnsData,
	data = [],
	loading,
	error,
	onFetch,
	tabButtons,
}: GenericDeviceTableProps<T>) {
	const { t } = useTranslation();
	const columns = useColumnConstructor({
		accessorData: columnsData,
		tableStyle: TableStyles_Types.primaryTable,
		canEdit: false,
	});

	const mobileXs = useMediaQuery(`(max-width: ${mediaQueriesNumbers.mobileXs}px)`); 

	const table = useReactTable({
		columns,
		data,
		getCoreRowModel: getCoreRowModel(),
		getSortedRowModel: getSortedRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
	});

	return (
		<frames.Page_inner>
			<PageHeader topHeader="Device Data" subHeader={subTitle || title} />
			
			<frames._page_inner_content>
				<TableLayout
					fillScreenTable
					searchbBarArea={mobileXs ? undefined : <AicoConnection inTable/>}
					buttonArea={<div style={{display: "flex", gap: "5px"}}>
						{mobileXs && <AicoConnection inTable/>}
						{tabButtons && <>{tabButtons}</>}
						<NewButton
							content="fetch"
							buttonType={ButtonTypes.tableButton}
							startEnhancer={glyphs.Fetch({})}
							onClick={onFetch}
							disabled={loading}
						/>
					</div>}
					tableArea={<>
						{loading && <div style={{padding: "20px", display: "flex", justifyContent: "center"}}><LoadingSpinner/></div>}
						{(!loading && (error || data.length === 0)) && <p style={{ ...css.emptyPen, textAlign: "center", padding: "20px" }}>{t("noData", { defaultValue: "no data" })}</p>}
						{!loading && !error && data.length !== 0 &&
							<ReactiveTable
								table={table}
								tableType={TableStyles_Types.primaryTable}
								emptyText=""
								renderFooter={false}
								minRows={30}
							/>
						}
					</>}
				/>
			</frames._page_inner_content>
		</frames.Page_inner>
	);
}
